import ModuleConfig from '@/contracts/core/module/config/ModuleConfig'

const modules: {[key:string]:ModuleConfig} = {
  'libre':new ModuleConfig('libre', 'Libre', 'v1', false),
  'note':new ModuleConfig('note', 'Note', 'v1', false),
  'education':new ModuleConfig('education', 'Education', 'v1', false),
}

export default {
  system: {
    version: 'v1',
    offline: 'true',
  },
  api: {
    version: 'v1',
    offline: 'true',
  },
  event: {
    version: 'v1',
  },
  systemModules: {
    auth: {
      version: 'v1',
      offline: 'false',
    },
    console: {
      version: 'v1',
      offline: 'true',
    },
    lockScreen: {
      version: 'v1',
      offline: 'true',
    },
    sync: {
      version: 'v1',
      offline: 'false',
    },
    share: {
      version: 'v1',
      offline: 'false',
    },
    winManager: {
      version: 'v1',
      offline: 'true',
    },
    modManager: {
      version: 'v1',
      offline: 'true',
    },
    update: {
      version: 'v1',
      offline: 'true',
    },
    groups: {
      version: 'v1',
      offline: 'false',
    },
  },
  modules: modules,
}
